import type { LandingAction, LandingFaqItem, LandingLocale } from './landingContent.js';
import type {
  StaticMissionStoryContent,
  StaticPageCardContent,
  StaticPageContent,
  StaticPageSectionContent,
} from './staticPageContent.js';
import type { GlobusJobsOverviewContent } from './globusJobContent.js';
import type { LocalizedGlobusJobContent } from './globusJobLocalization.js';

export type LocalizedCardCopy = Partial<StaticPageCardContent>;
export type LocalizedSectionCopy = Omit<Partial<StaticPageSectionContent>, 'cards'> & { cards?: LocalizedCardCopy[] };
export type LocalizedPageCopy = Partial<
  Pick<StaticPageContent, 'eyebrow' | 'title' | 'intro' | 'heroStageTitle' | 'heroHighlights'>
> & {
  heroGallery?: Array<{ imageAlt?: string }>;
  cards?: LocalizedCardCopy[];
  sections?: LocalizedSectionCopy[];
  globusJobs?: LocalizedGlobusJobContent[];
  globusJobsOverview?: Partial<GlobusJobsOverviewContent>;
  faq?: LandingFaqItem[];
  cta?: {
    eyebrow?: string;
    title?: string;
    text?: string;
    imageAlt?: string;
    primaryAction?: Partial<LandingAction>;
    secondaryAction?: Partial<LandingAction>;
  };
  contact?: Partial<NonNullable<StaticPageContent['contact']>>;
  missionStory?: StaticMissionStoryContent;
};

export type LocaleWithoutGerman = Exclude<LandingLocale, 'de'>;

export const action = (label: string): Partial<LandingAction> => ({ label });
export const card = (title: string, text: string, imageAlt?: string): LocalizedCardCopy => ({ title, text, imageAlt });
export const section = (
  eyebrow: string,
  title: string,
  text: string,
  cards?: LocalizedCardCopy[],
  imageAlt?: string,
): LocalizedSectionCopy => ({ eyebrow, title, text, cards, imageAlt });
export const faq = (question: string, answer: string) => ({ question, answer });
